<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <LockClosedIcon class="text-white w-12 h-12 mb-3" />
    <p class="text-white text-center font-bold text-xl mb-2">
      Your request to join the session has been sent.
    </p>
    <p class="text-white text-center font-bold text-xl mb-7">Waiting for clinician approval.</p>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { LockClosedIcon } from '@heroicons/vue/outline';

export default {
  name: 'CanJoinConsultationOverlay',
  props: {
    session: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  components: {
    LockClosedIcon,
  },

  setup(props) {
    onMounted(() => {
      window.Echo.private(`late.entry.${props.session.unique_id}`).listenForWhisper(
        'response',
        (response) => {
          if (response.userId === props.user.userUuid) {
            window.location.reload();
          }
        },
      );

      setTimeout(() => {
        window.Echo.private(`late.entry.${props.session.unique_id}`).whisper('entry-request', {
          showToast: true,
          name: props.user.name,
          id: props.user.unique_id,
          profile_photo_url: props.user.profile_photo_url,
        });
      }, 1000);
    });
  },
};
</script>

<style scoped>
.details {
  max-width: 415px;
}
</style>
